import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Factory, Hammer, Package, Zap, Truck, Droplet } from 'lucide-react';

const ApplicationsPage = () => {
  const industries = [
    {
      icon: Factory,
      name: 'Steel Plants',
      description: 'Heavy-duty conveyor systems, rolling mills, material handling',
      requirements: 'Heat resistant, high load capacity, abrasion resistant'
    },
    {
      icon: Hammer,
      name: 'Cement Plants',
      description: 'Raw material handling, clinker conveyors, grinding mills',
      requirements: 'Dust resistant, high tensile strength, chemical resistant'
    },
    {
      icon: Zap,
      name: 'Power Plants',
      description: 'Coal handling, ash handling, cooling systems',
      requirements: 'Temperature resistant, oil resistant, reliable performance'
    },
    {
      icon: Package,
      name: 'OEM Manufacturers',
      description: 'Custom belt solutions for machinery and equipment',
      requirements: 'Precise specifications, quality consistency, timely delivery'
    },
    {
      icon: Truck,
      name: 'Material Handling',
      description: 'Warehouses, distribution centers, logistics operations',
      requirements: 'Smooth operation, low maintenance, long service life'
    },
    {
      icon: Droplet,
      name: 'Food Processing',
      description: 'Packaging lines, processing equipment, sorting systems',
      requirements: 'Food grade materials, easy cleaning, corrosion resistant'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <div className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center">
            <h1 className="heading-font text-4xl text-[#1E293B] mb-4" data-testid="applications-title">
              INDUSTRIAL APPLICATIONS
            </h1>
            <p className="text-[#64748B] text-base max-w-2xl mx-auto">
              Serving diverse industries with specialized belt solutions
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((industry, index) => {
              const Icon = industry.icon;
              return (
                <div key={index} className="glass-card p-8 card-hover" data-testid={`industry-${index}`}>
                  <Icon className="text-[#3B82F6] mb-4" size={40} />
                  <h2 className="heading-font text-xl text-[#1E293B] mb-3">{industry.name}</h2>
                  <p className="text-[#64748B] text-sm mb-4">{industry.description}</p>
                  <div className="pt-4 border-t border-white/10">
                    <div className="text-[#3B82F6] text-xs font-semibold mb-2">KEY REQUIREMENTS</div>
                    <p className="text-[#64748B] text-xs">{industry.requirements}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-16 metal-gradient p-12 text-center">
            <h2 className="heading-font text-3xl text-[#1E293B] mb-4">YOUR INDUSTRY NOT LISTED?</h2>
            <p className="text-[#64748B] text-base mb-8 max-w-2xl mx-auto">
              We work with a wide range of industries and can customize solutions for your specific needs.
              Contact us to discuss your requirements.
            </p>
            <a href="mailto:sales@simpsonmunro.in" className="btn-accent inline-flex items-center justify-center px-8 py-3 text-[#1E293B] font-bold uppercase tracking-wider">
              Discuss Your Project
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ApplicationsPage;